(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-cx-add-to-cart]');
  if (!btn || btn.disabled) return;

  const variantId = btn.dataset.variantId;
  btn.disabled = true;

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);

  fetch(Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Accept': 'application/javascript',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: formData
  })
    .then((res) => res.json())
    .then((response) => {
      if (response.status) {
        // Shopify returned an error (e.g. sold out / invalid variant)
        console.error(response.description || response);
        btn.disabled = false;
        return;
      }

      // Success UI state on our button
      btn.classList.add('is-added');
      btn.querySelector('.complete-the-vibe__add-icon').hidden = true;
      btn.querySelector('.complete-the-vibe__add-check').hidden = false;

      // Let the theme's own pipeline take over: Alothemes.miniCart() listens
      // for this event, fetches /cart?section_id=minicart, and re-renders
      // #js_cart_popup with the updated cart (items, totals, item count,
      // free-shipping bar — all of it, automatically).
      document.body.dispatchEvent(new CustomEvent('ajax:addToCart', {
        detail: { response: response }
      }));

      // Open the drawer using the theme's real trigger, so its existing
      // sidePopup() toggle logic (.active / .act_opened / .pside_opened) runs
      // exactly as it does on a normal cart-icon click.
      const cartTrigger = document.querySelector('a.push_side[data-id="#js_cart_popup"]');
      const drawer = document.querySelector('#js_cart_popup');
      const alreadyOpen = drawer && drawer.classList.contains('act_opened');
      if (cartTrigger && !alreadyOpen) {
        cartTrigger.click();
      }

      setTimeout(() => {
        btn.disabled = false;
        btn.classList.remove('is-added');
        btn.querySelector('.complete-the-vibe__add-icon').hidden = false;
        btn.querySelector('.complete-the-vibe__add-check').hidden = true;
      }, 1800);
    })
    .catch((err) => {
      console.error('Add to cart failed:', err);
      btn.disabled = false;
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-grid"] && !Shopify.designMode) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function() {
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();
})();
